export default __webpack_public_path__ + "static/media/PSUP_black.lg.78aa693a.png";